import React from 'react';

function SplatterEight(props) {
    return(
        <svg style={props.stylez} version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="128.000000pt" height="128.000000pt" viewBox="0 0 1280.000000 1280.000000"
        preserveAspectRatio="xMidYMid meet">
        <metadata>
        Created by potrace 1.15, written by Peter Selinger 2001-2017
        </metadata>
        <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
             stroke="none">
            <path d="M1490 10340 c-19 -19 -19 -22 -5 -50 20 -39 60 -41 77 -5 9 19 8 29
            -6 50 -20 30 -39 32 -66 5z"/>
            <path d="M2907 10223 c-4 -3 22 -26 56 -50 50 -35 68 -43 92 -38 31 6 175 -26
            233 -52 18 -8 36 -11 41 -8 5 3 29 -1 53 -9 24 -8 72 -20 108 -27 36 -6 70
            -15 75 -19 6 -4 22 -10 38 -14 31 -7 36 -22 10 -29 -27 -6 62 -44 122 -52 28
            -3 82 -12 120 -20 39 -8 128 -24 198 -36 179 -28 372 -72 410 -91 18 -9 164
            -41 257 -57 25 -4 56 -14 70 -24 14 -9 52 -19 85 -23 33 -4 71 -15 85 -24 31
            -21 92 -38 191 -54 41 -7 81 -16 87 -20 34 -21 177 -48 272 -51 89 -3 119 -9
            200 -38 52 -19 127 -42 165 -51 86 -21 118 -33 172 -64 l43 -24 -33 -39 c-34
            -40 -75 -72 -182 -144 -33 -22 -61 -49 -63 -59 -4 -17 2 -18 60 -14 81 6 126
            -7 161 -45 31 -35 33 -45 13 -73 -14 -18 -15 -18 -22 0 -4 10 -2 27 5 37 12
            20 2 26 -16 8 -15 -15 -83 -29 -80 -17 1 6 -4 13 -12 16 -8 3 -11 0 -7 -7 7
            -11 -4 -15 -38 -11 -29 3 -86 43 -81 58 2 6 1 12 -4 12 -5 0 -11 9 -14 20 -3
            11 -12 20 -21 20 -9 0 -33 11 -54 24 -20 14 -65 34 -98 45 -53 18 -70 19 -120
            10 -92 -16 -126 -29 -162 -60 -18 -16 -37 -29 -42 -29 -6 0 -22 -26 -36 -57
            -15 -32 -30 -66 -35 -75 -12 -24 -29 -138 -25 -171 2 -15 12 -38 23 -50 26
            -29 66 -97 58 -97 -4 0 19 -25 51 -55 32 -30 56 -57 53 -60 -3 -3 -22 11 -42
            30 -20 19 -43 35 -50 35 -8 0 -17 7 -21 15 -3 8 -14 15 -24 15 -10 0 -34 18
            -53 41 -18 22 -50 50 -69 61 -19 11 -48 38 -65 61 -17 23 -44 45 -63 51 -18 6
            -36 16 -40 22 -4 6 -17 15 -30 19 -13 4 -40 21 -60 38 -20 18 -33 26 -28 20
            10 -17 -4 -16 -23 1 -18 17 -165 70 -261 94 -45 12 -85 32 -130 66 -36 26 -67
            51 -70 55 -3 5 -17 14 -31 22 -125 68 -199 144 -199 206 0 31 -24 78 -65 129
            -20 25 -122 68 -202 84 -49 11 -193 84 -233 120 -41 36 -66 57 -145 122 -113
            93 -138 113 -170 134 -16 10 -52 40 -79 67 -51 50 -69 55 -74 19 -2 -15 5 -25
            27 -37 17 -8 35 -24 41 -35 6 -11 26 -30 44 -43 82 -55 164 -123 196 -164 19
            -24 51 -53 70 -64 50 -28 193 -156 228 -205 17 -23 51 -58 76 -79 25 -20 46
            -42 46 -47 0 -18 80 -124 145 -193 93 -98 105 -132 114 -330 4 -88 6 -176 4
            -195 -2 -19 -6 -100 -8 -179 -3 -124 -6 -146 -23 -165 -11 -11 -31 -38 -45
            -60 -14 -21 -36 -44 -49 -50 -28 -14 -36 -57 -14 -76 19 -15 21 -81 4 -98 -7
            -7 -24 -12 -39 -12 -23 0 -63 35 -212 183 -101 100 -202 208 -225 239 -23 31
            -47 60 -53 63 -6 4 -18 19 -27 34 -23 38 -70 97 -112 141 -19 20 -53 58 -75
            85 -41 51 -242 262 -284 299 -13 12 -33 30 -45 42 -58 58 -116 105 -116 95 0
            -10 27 -39 72 -77 7 -6 25 -24 39 -40 15 -16 88 -89 163 -161 74 -73 146 -150
            160 -170 21 -34 86 -113 148 -181 12 -13 27 -34 34 -47 6 -12 31 -48 55 -80
            85 -112 81 -104 138 -280 24 -71 56 -152 73 -178 l31 -48 -61 -57 c-51 -48
            -64 -67 -81 -121 -12 -36 -21 -73 -21 -83 0 -10 -3 -18 -7 -18 -5 0 -9 -37
            -11 -83 -1 -45 -5 -102 -8 -127 -3 -25 -6 -70 -8 -100 -2 -30 -13 -77 -25
            -103 -32 -74 -24 -70 15 6 19 37 41 70 49 74 20 7 19 51 -1 98 -20 49 -11 111
            14 98 28 -13 135 -10 140 5 2 6 9 12 16 12 6 0 29 14 51 32 41 34 127 78 152
            78 55 0 141 114 128 168 -5 22 7 14 69 -48 41 -41 85 -93 97 -115 12 -22 33
            -54 46 -71 37 -49 32 -111 -12 -164 -19 -23 -35 -45 -35 -50 0 -4 -9 -10 -20
            -13 -38 -10 -34 -35 10 -80 25 -24 59 -76 81 -123 l39 -81 -10 -79 c-6 -43
            -13 -87 -16 -96 -9 -30 -105 -66 -184 -70 -14 -1 -30 -6 -37 -10 -14 -11 -101
            0 -109 13 -7 13 -41 11 -50 -2 -3 -6 3 -24 15 -40 11 -15 21 -35 21 -44 0 -8
            7 -15 15 -15 17 0 20 25 5 35 -25 16 8 25 83 25 87 -1 194 11 214 23 26 16 50
            -29 72 -137 19 -88 21 -113 11 -134 -9 -22 -9 -28 4 -38 9 -6 16 -20 17 -30 0
            -10 4 -28 9 -39 7 -15 9 -7 9 30 0 28 3 75 8 105 9 62 9 188 1 302 -7 89 6
            116 64 137 18 7 41 17 51 22 9 5 35 6 57 3 l40 -7 0 -103 c0 -140 -22 -183
            -75 -148 -21 14 -26 14 -30 2 -3 -8 -1 -27 5 -42 5 -15 8 -32 4 -37 -3 -5 2
            -9 10 -9 9 0 16 -4 16 -8 0 -5 15 -26 34 -48 19 -21 48 -56 66 -76 26 -31 35
            -36 50 -28 10 6 30 10 45 10 31 0 50 -39 41 -85 -6 -29 -38 -105 -57 -135 -5
            -8 -18 -33 -30 -55 -59 -117 -85 -147 -160 -196 -36 -23 -57 -29 -95 -28 -57
            1 -114 18 -114 34 0 6 14 37 31 69 17 31 29 59 27 61 -2 3 -17 -21 -33 -51
            -16 -31 -36 -59 -44 -62 -8 -3 -24 6 -37 21 -13 15 -27 27 -32 27 -5 0 -17 9
            -26 19 -10 11 -24 17 -32 14 -19 -7 -18 7 5 67 15 39 18 70 16 139 l-4 89 60
            61 c33 33 55 61 50 61 -6 0 -23 -14 -38 -32 -16 -18 -39 -41 -52 -53 -64 -55
            -62 -51 -46 -89 19 -45 19 -134 1 -183 -8 -21 -17 -55 -21 -76 -5 -34 -15 -43
            -107 -104 -77 -51 -110 -67 -137 -68 -31 0 -36 -3 -39 -26 -5 -45 23 -42 80 7
            61 53 136 99 145 90 3 -3 1 -17 -5 -31 -8 -16 -8 -25 -1 -25 5 0 16 15 24 33
            20 49 37 60 68 46 29 -13 41 -35 56 -101 13 -54 69 -141 87 -134 7 3 40 10 74
            17 37 7 81 25 109 43 25 17 69 39 97 49 49 17 51 17 97 -3 27 -12 58 -36 74
            -58 15 -20 30 -39 34 -42 32 -28 -1 -152 -60 -223 -76 -92 -169 -148 -232
            -141 -19 2 -58 5 -87 8 -60 4 -76 15 -102 66 -25 49 -72 70 -109 49 -31 -18
            -38 -43 -20 -76 20 -37 -5 -47 -55 -21 -49 25 -202 152 -218 181 -18 34 -118
            161 -134 170 -7 4 -14 14 -14 21 0 14 -64 76 -78 76 -15 0 -29 -16 -34 -37 -7
            -28 36 -78 79 -94 30 -10 138 -131 166 -184 21 -42 145 -164 173 -171 13 -3
            37 -24 52 -45 16 -21 40 -47 53 -57 42 -32 159 -92 180 -92 11 0 46 -13 78
            -30 72 -36 141 -34 205 5 66 41 69 42 123 69 29 14 59 26 67 26 9 0 31 14 49
            30 19 17 37 30 41 30 3 0 52 22 109 48 73 35 113 61 141 92 33 37 44 43 80 43
            60 1 146 -14 140 -24 -12 -20 9 -7 31 19 l23 27 -20 19 c-40 37 -3 148 65 197
            88 64 199 17 254 -108 13 -29 17 -69 18 -174 0 -122 2 -139 20 -159 16 -18 26
            -20 66 -15 43 6 52 3 103 -30 59 -40 86 -41 86 -2 0 40 -36 131 -72 183 -39
            56 -52 87 -67 162 -11 54 -3 94 35 164 8 14 14 35 14 45 0 27 28 63 49 63 10
            0 24 7 31 15 7 8 25 15 39 15 15 0 38 10 50 21 21 20 23 29 20 113 -3 116 6
            160 43 217 43 64 155 119 242 119 52 -1 76 -31 86 -109 4 -31 8 -52 9 -48 0 5
            13 -1 27 -12 27 -21 52 -25 91 -15 13 4 20 11 16 20 -3 10 5 16 25 20 18 4 32
            14 35 25 7 25 37 25 37 0 0 -11 -4 -23 -10 -26 -5 -3 -10 -17 -10 -31 0 -13
            -4 -24 -10 -24 -16 0 -41 -71 -33 -94 4 -12 6 -29 4 -39 -1 -10 5 -29 14 -43
            14 -21 19 -23 38 -13 35 20 150 110 172 136 27 33 59 22 50 -16 -4 -14 -7 -26
            -8 -26 -18 0 -43 -30 -49 -56 -11 -54 15 -90 101 -138 11 -7 10 -13 -3 -39
            -22 -42 -20 -104 4 -146 14 -27 20 -57 21 -121 2 -83 3 -86 28 -91 14 -3 34
            -9 43 -15 10 -5 28 -9 40 -9 28 -1 51 -17 67 -49 10 -17 15 -20 21 -11 6 9 11
            7 19 -9 11 -20 13 -20 28 -5 16 15 16 17 0 29 -21 15 -21 19 -1 61 19 40 31
            43 44 10 5 -14 18 -30 30 -36 19 -10 20 -9 14 14 -3 15 -2 26 4 26 14 0 2 43
            -15 53 -9 5 -13 21 -12 40 2 18 -1 62 -5 98 -7 56 -5 72 12 108 48 99 -2 272
            -113 391 -37 39 -55 69 -65 105 -7 28 -19 57 -27 66 -7 9 -21 39 -31 67 -22
            61 -80 132 -224 275 -86 84 -115 107 -137 107 -42 0 -65 32 -136 190 -32 72
            -98 153 -136 168 -19 8 -160 135 -233 209 -59 60 -133 115 -193 143 -24 11
            -43 24 -43 30 0 5 -7 10 -15 10 -8 0 -24 20 -35 45 -19 41 -100 135 -118 135
            -4 0 -44 35 -89 78 -83 79 -126 116 -177 154 -16 12 -41 40 -55 63 -59 94
            -132 153 -228 186 -32 10 -70 28 -85 39 -15 11 -31 20 -37 20 -12 0 -113 105
            -128 134 -7 13 -20 46 -28 72 -9 27 -20 58 -24 69 -5 11 -13 46 -19 79 -21
            107 -8 104 140 -41 65 -65 124 -119 129 -121 5 -2 9 -9 9 -16 0 -25 232 -238
            245 -224 2 2 -1 23 -5 48 -16 79 -13 94 19 106 23 9 36 8 67 -7 22 -10 44 -18
            50 -19 12 0 53 -41 53 -53 0 -16 41 -58 50 -53 5 4 29 0 53 -8 24 -7 66 -19
            93 -26 28 -7 70 -23 95 -35 25 -12 63 -28 85 -35 52 -17 178 -77 290 -139 78
            -42 90 -53 90 -75 -1 -16 3 -22 9 -16 9 9 46 -29 46 -49 0 -6 7 -11 16 -11 9
            0 24 -20 36 -47 11 -27 26 -51 32 -55 7 -5 6 -8 -3 -8 -12 0 -43 13 -161 69
            -56 26 -82 43 -87 57 -3 8 -11 14 -18 14 -7 0 -15 4 -17 8 -5 12 -87 76 -92
            71 -2 -2 32 -35 76 -73 87 -74 87 -75 58 -156 -22 -60 -38 -85 -58 -88 -31 -5
            -227 130 -314 216 -4 4 -31 31 -60 61 -132 133 -167 165 -174 159 -6 -6 40
            -57 201 -222 50 -51 99 -116 87 -116 -4 0 -28 14 -53 31 l-44 31 40 -36 c22
            -20 63 -52 90 -70 62 -41 145 -124 145 -144 0 -4 17 -18 38 -31 36 -23 122
            -120 122 -139 0 -11 75 -72 89 -72 5 0 19 -13 31 -30 18 -25 19 -30 6 -30 -9
            0 -16 -4 -16 -10 0 -5 7 -10 15 -10 8 0 25 -12 39 -26 16 -18 28 -24 37 -18
            25 15 63 3 91 -29 15 -18 27 -37 28 -44 0 -20 35 -34 48 -21 23 23 11 53 -39
            100 -37 35 -59 48 -81 48 -33 0 -108 35 -108 51 0 7 14 10 35 7 19 -2 35 -1
            35 3 0 4 14 11 32 14 18 4 48 20 68 35 49 39 76 46 89 22 12 -22 9 -48 -7 -64
            -21 -21 -13 -37 27 -49 50 -15 104 -5 138 26 27 25 28 25 8 40 -11 9 -36 20
            -56 25 -63 17 -98 82 -64 120 24 27 36 21 139 -72 22 -21 45 -38 49 -38 7 0
            77 -55 128 -100 9 -8 53 -42 98 -74 45 -33 97 -76 116 -97 32 -36 33 -40 28
            -97 -5 -53 -2 -66 20 -105 15 -24 38 -52 53 -62 38 -25 112 -16 163 19 70 49
            126 13 126 -83 1 -31 8 -70 17 -88 16 -32 16 -33 -3 -33 -17 0 -28 4 -79 31
            -8 4 -42 22 -75 39 -33 17 -81 45 -107 63 -26 17 -73 48 -104 67 -31 19 -74
            49 -96 67 -22 18 -45 30 -53 26 -9 -3 -27 8 -45 27 -17 18 -34 30 -37 26 -4
            -4 16 -30 43 -59 28 -28 63 -71 78 -94 16 -24 35 -43 42 -43 7 0 17 -6 21 -13
            4 -6 20 -18 36 -26 15 -8 27 -20 27 -26 0 -7 17 -19 38 -28 20 -9 60 -35 87
            -57 53 -44 136 -90 197 -109 20 -7 42 -19 49 -28 7 -8 22 -19 34 -24 125 -58
            159 -144 49 -123 -25 5 -34 3 -35 -7 -5 -53 19 -94 64 -115 l32 -15 -45 7
            c-25 3 -49 10 -54 15 -6 5 -18 9 -27 9 -41 0 -134 51 -157 85 -21 34 -54 46
            -67 25 -15 -24 38 -67 135 -109 213 -92 227 -99 256 -134 18 -22 24 -39 22
            -73 -1 -30 4 -50 15 -61 12 -12 13 -22 6 -41 -15 -40 -3 -69 50 -118 27 -25
            52 -55 55 -67 7 -29 56 -76 85 -82 12 -2 38 3 57 13 34 16 36 15 45 -1 6 -9
            24 -24 41 -33 41 -21 51 -7 44 64 -5 52 -4 53 34 77 27 17 60 27 102 30 69 6
            123 27 148 57 15 18 16 18 63 0 27 -10 52 -24 57 -31 5 -8 16 -11 30 -6 12 4
            48 2 80 -5 72 -15 100 -4 100 41 0 22 -9 39 -35 62 -19 17 -35 36 -35 43 0 13
            22 24 48 24 9 0 25 7 36 15 18 13 17 17 -20 82 -21 37 -56 108 -77 156 -34 79
            -65 126 -158 237 -16 19 -29 38 -29 42 0 5 -7 8 -15 8 -8 0 -50 27 -91 60 -42
            34 -100 72 -128 87 -28 14 -64 35 -81 47 -51 37 -242 156 -251 156 -4 0 -17 9
            -28 19 -12 10 -52 35 -89 55 -38 20 -84 49 -102 64 -19 15 -63 42 -98 60 -36
            18 -78 48 -94 65 -59 65 -116 109 -135 104 -11 -3 -22 1 -25 9 -3 8 -15 14
            -27 14 -25 0 -46 35 -46 77 0 21 -2 24 -15 13 -17 -14 -20 -46 -5 -55 6 -3 10
            -11 10 -16 0 -5 -21 6 -48 25 -65 49 -82 67 -80 84 4 19 -19 27 -24 9 -2 -10
            -28 5 -83 50 -44 35 -103 77 -131 94 -28 16 -71 47 -95 69 -36 32 -40 39 -24
            40 47 1 91 21 107 48 26 43 24 167 -2 236 -5 15 -9 30 -8 34 5 29 -76 141
            -146 202 -48 42 -110 80 -129 80 -10 0 -41 8 -71 19 -48 17 -57 17 -95 4 -42
            -14 -42 -14 -154 39 -62 28 -123 60 -137 69 -14 9 -52 31 -85 48 -33 17 -69
            37 -80 44 -11 6 -21 12 -21 12 -1 0 -5 14 -9 32 -6 32 -6 32 29 28 37 -5 61
            13 29 21 -11 3 -26 21 -35 39 l-15 34 49 53 c27 29 52 53 56 54 20 2 42 18 42
            30 0 8 7 14 15 14 18 0 20 30 3 31 -7 1 -28 0 -47 -1 l-34 -2 36 49 36 49 -50
            -1 c-27 -1 -49 2 -49 6 0 10 25 29 63 48 30 15 34 15 77 -5 25 -12 69 -29 99
            -39 33 -11 55 -24 58 -36 5 -17 43 -23 43 -7 0 26 71 -15 134 -77 7 -8 51 -33
            97 -57 116 -59 116 -59 112 -184 -4 -113 -1 -123 55 -191 23 -30 44 -44 68
            -49 19 -3 37 -10 40 -15 3 -5 26 -9 52 -9 66 0 113 40 158 136 19 40 34 81 34
            92 0 10 19 31 44 49 26 18 55 52 73 84 16 30 39 71 51 91 23 41 31 151 17 243
            -13 86 -110 286 -172 355 -45 50 -129 110 -154 110 -35 0 -158 106 -282 243
            -34 38 -82 83 -107 100 -25 17 -67 49 -95 73 -27 23 -81 63 -120 89 -80 54
            -112 56 -172 8 -19 -15 -44 -33 -55 -40 -21 -12 -108 -102 -108 -112 0 -4 -10
            -17 -23 -31 -38 -42 -64 -83 -75 -120 -37 -125 -63 -160 -133 -182 -54 -17
            -76 -17 -204 2 -107 15 -158 18 -180 10 -11 -4 -35 -3 -55 1 -19 4 -73 10
            -120 14 -47 3 -121 13 -165 22 -44 9 -100 17 -124 19 -24 1 -60 9 -80 17 -46
            19 -117 37 -206 52 -71 12 -173 39 -210 55 -11 5 -41 8 -67 8 -44 0 -144 27
            -216 58 -18 8 -53 14 -77 14 -39 0 -45 3 -51 25 -7 29 -29 33 -42 8 -9 -16
            -14 -16 -73 -1 -145 36 -205 51 -219 56 -8 3 -37 11 -65 18 -121 30 -173 43
            -210 54 -22 7 -56 14 -75 17 -19 3 -41 10 -48 16 -8 6 -35 14 -60 18 -81 12
            -225 50 -265 70 -22 10 -50 19 -64 19 -13 0 -33 5 -44 10 -10 6 -56 13 -100
            15 -45 3 -85 7 -89 10 -4 2 -10 2 -13 -2z m1057 -878 c25 -20 46 -39 46 -43 0
            -15 103 -123 130 -137 16 -8 67 -52 114 -97 l86 -81 0 -64 c0 -34 -4 -82 -9
            -105 -6 -24 -14 -69 -20 -101 -6 -32 -19 -70 -30 -86 -21 -29 -21 -31 -5 -152
            5 -35 2 -49 -11 -63 -10 -9 -22 -15 -28 -13 -25 8 -45 132 -52 307 -7 207 -26
            345 -52 389 -9 14 -39 49 -67 76 -105 103 -183 205 -158 205 5 0 30 -16 56
            -35z m2236 -119 c0 -14 -83 -70 -118 -79 -19 -5 -23 -2 -20 16 2 16 9 21 26
            20 12 -2 22 2 22 8 0 6 7 9 15 5 11 -4 15 1 15 17 0 32 19 48 42 36 10 -5 18
            -16 18 -23z m-586 -236 c4 0 4 4 1 10 -3 6 1 7 9 4 9 -3 16 -12 16 -20 0 -8 5
            -14 11 -14 5 0 7 5 4 10 -3 6 -3 15 1 21 3 6 14 -2 25 -21 19 -30 18 -50 -1
            -50 -5 0 -21 -11 -36 -25 -15 -14 -33 -25 -40 -25 -10 0 -14 -14 -15 -42 -2
            -71 -3 -73 -29 -73 -20 0 -25 5 -23 23 2 18 -2 22 -25 23 -24 0 -25 1 -7 10
            15 7 10 8 -18 4 -30 -5 -39 -2 -44 12 -4 9 -24 34 -45 54 -34 32 -51 70 -30
            69 4 0 29 -11 56 -25 66 -32 89 -22 41 18 -42 34 -35 57 12 39 27 -11 56 -16
            79 -13 6 1 9 15 6 34 l-4 32 25 -27 c13 -16 27 -28 31 -28z m468 -50 c10 0 18
            -7 18 -15 0 -19 -11 -19 -36 0 -10 8 -28 15 -39 15 l-20 1 20 9 c11 4 24 4 30
            -1 5 -5 17 -9 27 -9z m-328 -142 c-5 -30 -11 -38 -35 -43 -16 -4 -33 -4 -38
            -1 -13 9 -1 88 17 109 15 17 17 17 39 -5 18 -19 21 -30 17 -60z m241 28 c11
            -8 24 -12 30 -9 29 11 51 -59 24 -75 -28 -17 -46 -15 -94 13 -52 31 -74 54
            -54 57 8 0 19 2 24 3 6 2 16 3 23 4 7 0 10 6 7 11 -9 15 18 12 40 -4z m-485
            -120 c7 -10 8 -21 3 -31 -8 -14 -11 -14 -27 4 -10 11 -15 25 -11 30 9 15 20
            14 35 -3z m262 -108 c-9 -9 -15 -9 -23 -1 -7 7 -9 20 -5 29 6 16 8 16 23 1 13
            -13 15 -19 5 -29z m56 -10 c17 -17 15 -28 -6 -28 -19 0 -42 18 -42 32 0 12 35
            9 48 -4z m-420 -68 c9 -5 29 -14 45 -20 17 -6 27 -17 27 -30 0 -27 -9 -25 -58
            12 -50 38 -60 64 -14 38z m-1306 -324 c-5 -77 -11 -101 -24 -110 -25 -15 -28
            -7 -32 72 -4 66 -2 74 27 113 17 23 32 38 34 33 1 -5 -1 -54 -5 -108z m-429
            47 c102 -93 230 -223 224 -229 -11 -12 -121 -41 -136 -37 -27 8 -90 92 -102
            136 -6 23 -22 70 -35 104 -13 34 -24 64 -24 67 0 16 25 1 73 -41z m797 -58
            c32 -35 17 -45 -49 -35 -53 9 -96 35 -85 51 3 5 29 9 58 9 43 0 57 -4 76 -25z
            m-194 -160 c27 -8 60 -15 74 -15 37 0 145 -57 189 -100 29 -29 40 -48 45 -83
            6 -41 3 -53 -34 -119 -74 -130 -104 -150 -177 -116 -45 21 -87 60 -193 177
            -30 33 -83 90 -117 126 -70 72 -79 102 -35 110 15 3 52 12 82 19 73 19 107 19
            166 1z m2304 -55 c28 -16 53 -30 57 -30 3 0 26 -15 52 -34 25 -18 79 -50 119
            -70 39 -20 72 -41 72 -46 0 -6 5 -10 11 -10 6 0 17 -7 25 -15 9 -8 27 -15 42
            -15 18 0 60 -25 122 -70 111 -81 232 -176 263 -206 12 -11 34 -29 49 -38 41
            -27 91 -106 77 -123 -17 -20 -45 -16 -89 12 -22 14 -44 25 -49 25 -5 0 -14 7
            -22 16 -7 8 -44 33 -83 55 -98 56 -170 100 -176 108 -3 4 -12 12 -21 17 -23
            12 -123 99 -173 150 -33 33 -47 41 -71 39 -16 -2 -36 1 -45 6 -11 7 -9 8 10 3
            19 -5 22 -3 14 5 -6 7 -22 13 -35 14 -13 2 -39 10 -56 20 -26 14 -33 24 -33
            47 0 23 -4 30 -20 30 -13 0 -20 7 -20 19 0 10 -7 22 -16 25 -9 4 -14 9 -10 13
            8 8 -23 43 -38 43 -7 0 -12 9 -13 20 -2 25 -3 26 57 -10z m-2608 -4 c7 -8 22
            -26 33 -42 11 -15 26 -34 34 -41 20 -20 12 -23 -39 -11 -25 6 -64 10 -88 9
            -43 -1 -73 9 -104 37 -17 14 -17 16 0 28 9 7 31 14 47 14 17 0 37 5 45 10 22
            14 57 12 72 -4z m-224 -78 c2 -10 -8 -20 -26 -26 -16 -5 -45 -24 -65 -42 -54
            -47 -45 -23 14 38 50 52 71 60 77 30z m3102 -218 c6 -11 9 -20 7 -20 -2 0 -12
            9 -22 20 -10 11 -13 20 -7 20 6 0 16 -9 22 -20z m995 -651 c0 -31 -32 -36 -77
            -12 l-33 18 35 3 c19 2 39 8 45 13 15 15 30 4 30 -22z m399 -250 c29 -23 82
            -107 73 -116 -10 -9 -92 75 -104 107 -13 35 -5 38 31 9z m-1517 -274 c-3 -26
            -8 -30 -29 -23 -7 3 -7 11 3 26 18 29 30 28 26 -3z m-7 -82 c0 -10 -3 -28 -6
            -41 -5 -17 -10 -20 -20 -11 -7 6 -11 17 -8 25 2 8 6 21 9 29 6 21 25 19 25 -2z
            m1540 -78 c10 -12 10 -18 0 -30 -11 -13 -17 -12 -51 7 -27 15 -35 24 -27 30
            21 13 65 9 78 -7z m132 -92 c17 -15 25 -43 13 -43 -3 0 -24 9 -47 21 -31 16
            -38 23 -27 30 21 13 40 11 61 -8z"/>
            <path d="M5568 8903 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
            <path d="M5530 8836 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z"/>
            <path d="M1671 10081 c17 -22 45 -45 63 -51 17 -6 39 -16 48 -21 28 -14 30
            -11 13 19 -17 28 -66 62 -90 62 -7 0 -15 7 -19 15 -3 8 -15 15 -26 15 -19 0
            -19 -3 11 -39z"/>
            <path d="M5650 10019 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
            -10 -5 -10 -11z"/>
            <path d="M5960 9920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
            -4 -4 -4 -10z"/>
            <path d="M4500 9624 c0 -17 30 -74 40 -74 9 0 22 -33 25 -60 1 -8 17 -40 36
            -70 19 -30 38 -63 42 -72 3 -10 11 -18 17 -18 5 0 10 -6 10 -12 0 -25 70 -101
            115 -124 52 -28 55 -24 20 22 -14 18 -25 39 -25 47 0 8 -9 26 -20 40 -11 14
            -20 29 -20 34 -1 14 -44 59 -62 66 -10 4 -18 15 -18 26 0 11 -14 31 -31 43
            -17 13 -39 39 -49 58 -22 42 -79 109 -80 94z"/>
            <path d="M2600 9383 c0 -5 13 -17 28 -27 l27 -19 -24 26 c-26 28 -31 32 -31
            20z"/>
            <path d="M2710 9291 c0 -5 12 -17 28 -26 l27 -18 -24 27 c-26 28 -31 31 -31
            17z"/>
            <path d="M4604 9265 c-8 -20 13 -45 37 -45 21 0 24 12 9 41 -13 23 -38 25 -46
            4z"/>
            <path d="M3735 9200 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
            -8 -4 -11 -10z"/>
            <path d="M3412 8879 c2 -6 8 -10 13 -10 5 0 11 4 13 10 2 6 -4 11 -13 11 -9 0
            -15 -5 -13 -11z"/>
            <path d="M3656 8661 c-9 -15 23 -36 36 -23 5 5 7 15 4 21 -9 13 -33 14 -40 2z"/>
            <path d="M5220 8666 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
            -15 -2 -15 -4z"/>
            <path d="M3217 8116 c-7 -17 18 -40 33 -31 7 4 7 12 0 26 -13 23 -26 25 -33 5z"/>
            <path d="M2140 7850 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
            -10 -4 -10 -10z"/>
            <path d="M6690 7346 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
            <path d="M6950 7182 c0 -26 45 -56 66 -44 14 8 12 12 -12 29 -50 34 -54 35
            -54 15z"/>
            <path d="M3455 7160 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
            -8 -4 -11 -10z"/>
            <path d="M3447 7133 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
            -9 2 -12 -2z"/>
            <path d="M3400 7039 c-42 -86 -51 -109 -41 -109 10 0 84 160 77 167 -3 3 -19
            -23 -36 -58z"/>
            <path d="M7188 6912 c39 -39 47 -44 50 -28 5 24 -39 68 -71 72 -22 2 -20 -2
            21 -44z"/>
            <path d="M3338 6905 c-3 -11 -9 -29 -13 -40 -3 -11 1 -7 10 8 9 16 15 33 12
            40 -2 6 -6 3 -9 -8z"/>
            <path d="M3293 6794 c-6 -13 -7 -24 -3 -24 9 0 25 39 18 45 -2 2 -8 -7 -15
            -21z"/>
            <path d="M3885 6530 c-4 -6 -3 -16 3 -22 6 -6 12 -6 17 2 4 6 3 16 -3 22 -6 6
            -12 6 -17 -2z"/>
            <path d="M3923 6255 c-7 -20 2 -29 21 -22 9 4 13 13 10 22 -8 19 -23 19 -31 0z"/>
            <path d="M4401 6244 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
            <path d="M7793 6103 c-12 -2 -27 -11 -33 -19 -7 -8 -21 -14 -31 -14 -11 0 -19
            -4 -19 -10 0 -5 5 -9 12 -7 8 1 13 -13 13 -43 0 -44 0 -45 42 -54 52 -11 65
            -2 93 62 25 56 25 69 1 82 -20 10 -38 11 -78 3z"/>
            <path d="M4032 5944 c-24 -24 -40 -44 -37 -44 10 0 78 60 88 77 16 27 -9 11
            -51 -33z"/>
            <path d="M3918 5864 c-27 -14 -48 -31 -48 -39 0 -25 23 -16 69 25 50 46 45 49
            -21 14z"/>
            <path d="M7766 5855 c4 -8 10 -15 15 -15 5 0 9 7 9 15 0 8 -7 15 -15 15 -9 0
            -12 -6 -9 -15z"/>
            <path d="M7728 5783 c-20 -5 -25 -18 -34 -83 -4 -32 -3 -50 4 -50 5 0 25 -14
            43 -31 32 -29 71 -40 87 -25 12 13 5 81 -13 116 -15 29 -61 83 -68 79 -1 -1
            -9 -3 -19 -6z"/>
            <path d="M6140 5710 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
            0 -3 -5 5 -10z"/>
            <path d="M6267 5703 c-24 -23 13 -93 48 -93 16 0 55 34 55 48 0 5 -9 18 -20
            30 -20 21 -69 30 -83 15z"/>
            <path d="M2690 5556 c0 -7 -7 -26 -14 -42 -15 -28 -13 -44 5 -44 14 0 42 69
            35 86 -7 18 -26 18 -26 0z"/>
            <path d="M5395 5539 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
            <path d="M6566 5365 c4 -8 10 -12 15 -9 14 8 10 24 -6 24 -9 0 -12 -6 -9 -15z"/>
            <path d="M2337 5324 c-12 -13 14 -44 37 -44 26 0 51 24 41 40 -7 11 -68 14
            -78 4z"/>
            <path d="M8974 5273 c-14 -34 -21 -108 -13 -156 4 -31 47 -41 92 -21 58 26 72
            81 40 149 -9 20 -24 35 -34 35 -9 0 -22 7 -29 15 -20 25 -39 17 -56 -22z"/>
            <path d="M7056 5203 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"/>
            <path d="M7194 5189 c-10 -12 -29 -25 -41 -30 -36 -14 -26 -38 12 -29 6 1 28
            3 49 4 45 1 68 25 50 54 -16 25 -47 26 -70 1z"/>
            <path d="M5174 5113 c-36 -50 -52 -119 -65 -278 -4 -60 -11 -121 -15 -135 -4
            -14 -8 -63 -9 -110 -1 -47 -5 -98 -9 -113 -4 -15 -3 -35 2 -44 10 -17 17 29
            28 187 3 47 10 92 14 100 4 8 11 53 14 100 13 180 17 201 47 235 30 34 35 51
            21 73 -6 9 -14 4 -28 -15z"/>
            <path d="M8855 5061 c3 -5 31 -23 62 -40 56 -31 93 -39 93 -22 0 13 -47 41
            -69 41 -11 0 -22 4 -26 10 -3 5 -12 7 -19 4 -8 -3 -17 -1 -21 5 -3 6 -11 11
            -16 11 -6 0 -8 -4 -4 -9z"/>
            <path d="M5015 4950 c-19 -21 -19 -22 -1 -36 14 -10 23 -11 33 -3 16 14 16 21
            0 43 -12 16 -14 16 -32 -4z"/>
            <path d="M9096 4782 c-21 -20 -45 -57 -53 -82 -8 -25 -22 -53 -30 -62 -34 -38
            26 -128 66 -99 9 6 25 15 36 20 11 5 31 21 44 35 19 20 34 26 67 26 54 0 65
            17 31 45 -21 16 -28 32 -31 65 -3 34 -10 49 -32 67 -39 31 -53 29 -98 -15z"/>
            <path d="M1470 4650 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
            -16 -4 -16 -10z"/>
            <path d="M7312 4610 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
            <path d="M4433 4603 c-18 -7 -16 -48 2 -63 33 -27 64 27 33 58 -13 13 -16 13
            -35 5z"/>
            <path d="M9060 4495 c0 -8 27 -42 60 -75 41 -41 60 -68 60 -85 0 -35 -49 -133
            -70 -140 -29 -9 -12 -42 34 -63 50 -24 157 -52 197 -52 21 0 32 7 44 30 8 16
            15 38 15 49 0 11 9 22 20 26 16 5 19 12 14 27 -3 11 -8 32 -10 47 -14 100 -15
            102 -62 132 -50 32 -93 37 -112 14 -7 -8 -22 -15 -34 -15 -25 1 -76 43 -76 64
            0 17 -46 56 -66 56 -8 0 -14 -7 -14 -15z"/>
            <path d="M4555 4391 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
            <path d="M5367 4343 c-10 -10 -8 -81 2 -87 8 -6 21 39 21 75 0 19 -11 25 -23
            12z"/>
            <path d="M4470 4245 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0
            -15 -7 -15 -15z"/>
            <path d="M5101 4244 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
            <path d="M4397 4222 c-25 -17 -87 -80 -87 -89 0 -3 5 -13 10 -23 16 -30 69
            -18 102 22 21 25 27 42 24 68 -4 41 -13 45 -49 22z"/>
            <path d="M5100 4191 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 -5
            3 -10 -3 -10 -14z"/>
            <path d="M4230 4170 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
            -4 -4 -4 -10z"/>
            <path d="M7370 4100 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
            -10 -4 -10 -10z"/>
        </g>
    </svg>
    )
}

export default SplatterEight;